module.exports = __webpack_public_path__ + "img/1505486845.68437672.jpg";